import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { IconButton, Typography } from '@mui/material';
import { deleteIOExtension } from 'console/climatic/utils/deleteIOExtension';
import { Delete } from '@mui/icons-material';
import { useConfigurationState } from 'z3k-settings/climatic/configuration/lib/useConfigurationState';
import { HeatingCard } from 'z3k-settings/climatic/configuration/ui/heating-card';
import { useContext } from 'react';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
export function IoExtensionsCard({ io, index }) {
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const { blackList, io_extensions, object_arrays, circuits } = useConfigurationState();
    const relatedList = io.related_list;
    const allUsedIds = object_arrays
        .filter((obj) => relatedList?.includes(obj.id))
        .map((obj) => obj.objects_links);
    return (_jsxs(SettingCard, { title: `${io.name}: ${index + 1}`, header_props: {
            action: (_jsx(IconButton, { onClick: () => {
                    const new_config = deleteIOExtension(config, io.id)?.config;
                    if (!new_config)
                        return;
                    replace_config(new_config);
                }, children: _jsx(Delete, {}) })),
        }, children: [_jsxs(Typography, { children: ["\u0421\u0435\u0440\u0438\u0439\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440: ", io.serial] }), Object.entries(circuits)
                .filter(([index, circuit]) => allUsedIds.some((list) => list.includes(circuit.id)))
                .map(([index, circuit]) => {
                return (_jsx(HeatingCard, { number: Number(index) + 1, heating_settings: circuit }, circuit.id));
            })] }));
}
